/**
 * Pipeline API client for /api/v1/me/pipeline/*.
 * Image Creator requests acquire the shared generation contract at this one
 * transport boundary; all other payloads pass through unchanged.
 */
import { apiRequest } from "./api";
import { imageGenerationKernel } from "@orion/image-generation-contract";

let relayMediaCatalog = false;

export function useRelayMediaCatalog() { relayMediaCatalog = true; }

export function listPipelineCandidates(params = {}) {
  const search = new URLSearchParams();
  if (params.app_code) {
    search.set("app_code", params.app_code);
  }
  if (params.all_apps) {
    search.set("all_apps", "1");
  }
  if (params.stage) {
    search.set("stage", params.stage);
  }
  if (params.media_type) {
    search.set("media_type", params.media_type);
  }
  if (relayMediaCatalog && (params.stage || "creator") === "creator" && ["image", "video"].includes(params.media_type)) {
    search.set("catalog_source", "relay");
  }
  const query = search.toString();
  const path = query
    ? `/api/v1/me/pipeline/candidates?${query}`
    : "/api/v1/me/pipeline/candidates";
  return apiRequest(path);
}

export function listPipelineRuns(params = {}) {
  const search = new URLSearchParams();
  if (params.app_code) {
    search.set("app_code", params.app_code);
  }
  if (params.all_apps) {
    search.set("all_apps", "1");
  }
  if (params.media_type) {
    search.set("media_type", params.media_type);
  }
  if (params.stage) {
    search.set("stage", params.stage);
  }
  if (params.status) {
    search.set("status", params.status);
  }
  if (params.limit) {
    search.set("limit", String(params.limit));
  }
  if (params.offset) {
    search.set("offset", String(params.offset));
  }
  if (params.summary) {
    search.set("summary", "1");
  }
  if (params.view) {
    search.set("view", params.view);
  }
  const query = search.toString();
  const path = query
    ? `/api/v1/me/pipeline/runs?${query}`
    : "/api/v1/me/pipeline/runs";
  return apiRequest(path);
}

export function getPipelineRun(runId, { view = "detail" } = {}) {
  const search = new URLSearchParams({ run_id: runId, view });
  return apiRequest(`/api/v1/me/pipeline/runs?${search}`);
}

export function submitPipelineRun(input) {
  const payload = imageGenerationKernel.attachCreatorIntent(input);
  return apiRequest("/api/v1/me/pipeline/runs", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function listCreatorCandidates(params = {}) {
  return listPipelineCandidates({ ...params, stage: "creator" });
}

export function listDirectorCandidates(params = {}) {
  return listPipelineCandidates({ ...params, stage: "director" });
}

export function listCreatorRuns(params = {}) {
  return listPipelineRuns({ ...params, stage: "creator" });
}

export function listDirectorRuns(params = {}) {
  return listPipelineRuns({ ...params, stage: "director" });
}

export function listGoodsDetailBatches(params = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const query = search.toString();
  return apiRequest(query ? `/api/v1/me/goods-detail/batches?${query}` : "/api/v1/me/goods-detail/batches");
}

export function getGoodsDetailBatch(detailBatchID) {
  const id = encodeURIComponent(String(detailBatchID || "").trim());
  return apiRequest(`/api/v1/me/goods-detail/batches/${id}`);
}
